import React$1 from 'react';

const External = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6",
  height: "16"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M3 0l3 5H4v11H2V5H0l3-5z"
}));

export default External;
